import {DataObject} from "./dataObject";
//import TimeStamp from "../timeStamp";
import store from "../../store/store";
/*import {db} from "../db";
import SpielService from "./spielService";*/
import FirebaseWrite from "@/services/database/firebaseWrite";

export class SaisonFrist extends DataObject {
    constructor(){
        super();
        this.id = '';
        this.gast = null;
        this.heim = null;
    }

    async updateNew(){
        return FirebaseWrite.update('fristen', this.id,
            this.local.documentUpdates
        )
    }

    async addNew(id){
        this.id = id;
        const dataObject = this.getDbObject();
        return FirebaseWrite.set('fristen', id,
            dataObject
        )
    }

    updateInStore(){
        let updatedDoc = this.getDbObject();
        updatedDoc.id = this.id;
        const docIndex = store.state.snapshots.bestaetigungsfristen.find(
            frist => frist.id === updatedDoc.id
        );
        store.state.snapshots.bestaetigungsfristen.splice(docIndex, 1, updatedDoc)
    }

    addToStore(){
        let updatedDoc = this.getDbObject();
        updatedDoc.id = this.id;
        store.state.snapshots.bestaetigungsfristen.push(updatedDoc)
    }
}